export const camelCaseToWords = (camelCaseStr) => {
  if (!camelCaseStr) return '';
  
  // Handle special case for abbreviations like 'ID' or 'API'
  if (camelCaseStr === camelCaseStr.toUpperCase()) {
    return camelCaseStr;
  }

  // Insert space before capital letters and numbers
  const withSpaces = camelCaseStr.replace(/([A-Z]|\d+)/g, ' $1');
  
  // Capitalize first letter of each word and lowercase the rest
  return withSpaces
    .split(' ')
    .map(word => {
      // Handle words that start with numbers
      if (/^\d+$/.test(word)) return word;
      
      // Preserve abbreviations (2+ uppercase letters together)
      if (/^[A-Z]{2,}$/.test(word)) return word;
      
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ')
    .trim();
};